import { render, staticRenderFns } from "./adrSuggest.vue?vue&type=template&id=7c52b0a9&"
import script from "./adrSuggest.vue?vue&type=script&lang=ts&"
export * from "./adrSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./adrSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports